import { DISABLE_NEARBY_SUPPLIER_DELIVERY_TYPES } from '@/mixins/constants'
import * as Comlink from 'comlink'
import * as types from '../mutation-types'
import OrderFormWorker from './../../utils/workers/web-workers/order-form.worker.js'
const orderFormWorker = new OrderFormWorker()
const helper = Comlink.wrap(orderFormWorker)

const state = {
  supplier_locations: [],
  get_nearby_suppliers_duration: 15000,
  get_nearby_suppliers_interval: undefined,
  activated_point_marker: undefined
}

// getters
const getters = {
  nearbySuppliers: (state) => state.supplier_locations,
  activatedPointMarker: (state) => state.activated_point_marker
}

// actions
const actions = {
  resetNearbySuppliers({ commit, rootState }) {
    commit(types.RESET_NEARBY_SUPPLIERS, { rootState })
  },
  getNearbySuppliers({ commit, rootState }, params) {
    commit(types.GET_NEARBY_SUPPLIERS, { rootState, params })
  },
  initGetNearbySuppliersInterval({ commit, rootState }, params) {
    commit(types.CLEAR_GET_NEARBY_SUPPLIERS_INTERVAL)
    commit(types.INIT_GET_NEARBY_SUPPLIERS_INTERVAL, { rootState, params })
  },
  clearGetNearbySuppliersInterval({ commit }) {
    commit(types.CLEAR_GET_NEARBY_SUPPLIERS_INTERVAL)
  },
  setActivatedPointMarker({ commit }, data) {
    commit(types.SET_ACTIVATED_POINT_MARKER, data)
  }
}

// mutations
const mutations = {
  [types.RESET_NEARBY_SUPPLIERS](state) {
    state.supplier_locations = []
  },
  async [types.GET_NEARBY_SUPPLIERS](state, { rootState, params }) {
    const orderPathHasOnlyOnePoint = !(
      rootState.orderForm &&
      rootState.orderForm.path &&
      rootState.orderForm.path.length > 1 &&
      rootState.orderForm.estimatedFee &&
      rootState.orderForm.estimatedFee.polylines
    )

    const isInstantService =
      rootState.orderForm &&
      rootState.orderForm.service &&
      DISABLE_NEARBY_SUPPLIER_DELIVERY_TYPES.indexOf(rootState.orderForm.service.delivery_type) ===
        -1

    if (rootState.isFocusTab && isInstantService && orderPathHasOnlyOnePoint) {
      const locations = await helper.getNearbySuppliers(params)
      state.supplier_locations = locations
    }
  },
  async [types.INIT_GET_NEARBY_SUPPLIERS_INTERVAL](state, { rootState, params }) {
    state.get_nearby_suppliers_interval = setInterval(async () => {
      const orderPathHasOnlyOnePoint = !(
        rootState.orderForm &&
        rootState.orderForm.path &&
        rootState.orderForm.path.length > 1 &&
        rootState.orderForm.estimatedFee &&
        rootState.orderForm.estimatedFee.polylines
      )

      const isInstantService =
        rootState.orderForm &&
        rootState.orderForm.service &&
        DISABLE_NEARBY_SUPPLIER_DELIVERY_TYPES.indexOf(
          rootState.orderForm.service.delivery_type
        ) === -1

      if (rootState.isFocusTab && isInstantService && orderPathHasOnlyOnePoint) {
        const locations = await helper.getNearbySuppliers(params)
        state.supplier_locations = locations
      }
    }, state.get_nearby_suppliers_duration)
  },
  async [types.CLEAR_GET_NEARBY_SUPPLIERS_INTERVAL](state) {
    if (state.get_nearby_suppliers_interval) {
      clearInterval(state.get_nearby_suppliers_interval)
      state.get_nearby_suppliers_interval = null
    }
  },
  [types.SET_ACTIVATED_POINT_MARKER](state, data) {
    state.activated_point_marker = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
